import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppFloating = () => {
  const [isHovered, setIsHovered] = useState(false);
  const whatsappNumber = '33644182790'; // Format international
  const message = encodeURIComponent('Bonjour, je souhaite obtenir des informations sur vos services de plomberie.');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Écrire sur WhatsApp"
    >
      {/* Tooltip */}
      <div
        className={`absolute bottom-full right-0 mb-2 px-4 py-2 bg-[#0B2A4A] text-white text-sm font-medium rounded-lg shadow-lg whitespace-nowrap transition-all duration-300 ${
          isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'
        }`}
      >
        Écrire sur WhatsApp
        <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-[#0B2A4A]"></div>
      </div>

      {/* Button */}
      <div className="relative">
        {/* Pulse animation */}
        <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-75"></div>
        
        {/* Main button */}
        <div className="relative w-14 h-14 bg-[#25D366] hover:bg-[#20BA5A] rounded-full shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-300 transform hover:scale-110">
          <MessageCircle className="w-7 h-7 text-white" fill="currentColor" />
        </div>

        {/* Notification badge */}
        <div className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center">
          <span className="text-white text-xs font-bold">1</span>
        </div>
      </div>
    </a>
  );
};

export default WhatsAppFloating;
